import React, { useContext } from 'react';
import { List } from '@sm/wds-react';
import { SubMenuLink } from './components/SubMenuLink';
import { SeeMoreLink } from './components/SeeMoreLink';
import {
  surveymonkey,
  enterprise,
  integrations,
  audience,
  cx,
  engage,
  usabilla,
  techValidate,
  apply,
  wufoo,
  getFeedback,
  viewAllProducts,
  addIntegrations,
} from '../../config/linkInfo.js';
import SMHeaderContext from '../../SMHeaderContext.js';

import './mobile-menu-anon.scss';

export const ProductsMenu = () => {
  const { lang, isEUDC } = useContext(SMHeaderContext);
  return (
    <List interactive transparent noRules>
      <Choose>
        <When condition={lang === 'en'}>
          <SubMenuLink {...surveymonkey()} />
          <SubMenuLink {...enterprise()} />
          <SubMenuLink {...integrations()} />
          <If condition={!isEUDC}>
            <SubMenuLink {...audience()} />
          </If>
          <SubMenuLink {...cx()} />
          <SubMenuLink {...engage()} />
          <SubMenuLink {...usabilla(lang)} />
          <SubMenuLink {...techValidate()} />
          <SubMenuLink {...apply()} />
          <SubMenuLink {...wufoo()} />
          <SubMenuLink {...getFeedback()} />
        </When>
        <When condition={lang === 'fr'}>
          <SubMenuLink {...surveymonkey(lang)} />
          <SubMenuLink {...audience()} />
          <SubMenuLink {...apply()} />
          <SubMenuLink {...usabilla(lang)} />
        </When>
        <Otherwise>
          <SubMenuLink {...surveymonkey()} />
          <SubMenuLink {...audience()} />
          <SubMenuLink {...usabilla(lang)} />
        </Otherwise>
      </Choose>
      <SeeMoreLink {...viewAllProducts(lang)} />
      <If condition={lang !== 'en'}>
        <SeeMoreLink {...addIntegrations()} />
      </If>
    </List>
  );
};

export default ProductsMenu;
